import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
import{erpplatserver} from '@/utils/baseUrl';

/*消耗退回*/
//获取消耗退回列表
export async function getXhThList(params) {
    return post(erpserver+'/feedProduce/getXhThList', params, true)
}
//保存消耗退回
export async function saveXhTh(params) {
    return post(erpserver+'/feedProduce/saveXhTh', params, true)
}


//获取产出消耗列表
export async function getConsumeList(params) {
    return post(erpserver+'/feedProduce/getConsumeList', params, true)
}


//获取领用申请列表
export async function getPickingReqListSc(params) {
    return post(erpserver+'/pickingList/getPickingReqListSc', params, true)
}



// 获取领料单详情
export async function getPickingListSc(params) {
    return post(erpserver+'/pickingList/getPickingListSc', params, true);
}



/*投料*/

//查看投料
export async function getFeedingDetails(params) {
    return post(erpserver+'/feedProduce/getFeedingDetails', params, true);
}
// 新增 编辑
export async function saveFeeding(params) {
    return post(erpserver+'/feedProduce/saveFeeding', params, true);
}
//获取投料列表
export async function getFeedList(params) {
    return post(erpserver+'/feedProduce/getFeedList', params, true);
}
/*产出*/
//获取生产线列表
export async function getSclineList(params) {
    return post(erpserver+'/feedProduce/getSclineList', params, true);
}
//获取生产批次号
export async function isExistVcno(params) {
    return post(erpserver+'/feedProduce/isExistVcno', params, true);
}
// 获取产成品
export async function getFinishedProductList(params) {
    return post(erpserver+'/feedProduce/getFinishedProductList', params, true);
}
// 获取在线库存列表
export async function getOnlineStockList(params) {
    return post(erpserver+'/feedProduce/getOnlineStockList', params, true);
}
// 新增 编辑
export async function saveProduce(params) {
    return post(erpserver+'/feedProduce/saveProduce', params, true);
}
//查看产出
export async function getProduceDetails(params) {
    return post(erpserver+'/feedProduce/getProduceDetails', params, true);
}
/*在线退回*/
//获取在线退回列表
export async function getOnlineReturnList(params) {
    return post(erpserver+'/feedProduce/getOnlineReturnList', params, true);
}
//保存
export async function saveOnlineReturn(params) {
    return post(erpserver+'/feedProduce/saveOnlineReturn', params, true);
}

/*投料*/
//上传图片
export async function upload(params) {
    return post(erpplatserver+'/system/uploadFile',params,false);
}

